import HeroIcon from './HeroIcon';
export default HeroIcon;
